import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, signal } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-offline-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isOffline()) {
      <div class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2.5 rounded-full bg-slate-900 px-5 py-3 text-sm font-medium text-white shadow-lg">
        <span class="h-2 w-2 rounded-full bg-red-400"></span>
        No internet connection
      </div>
    }
  `,
})
export class OfflineIndicatorComponent implements OnInit, OnDestroy {
  readonly isOffline = signal(false);

  private readonly isBrowser: boolean;
  private readonly onOnline = () => this.isOffline.set(false);
  private readonly onOffline = () => this.isOffline.set(true);

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;
    this.isOffline.set(!navigator.onLine);
    window.addEventListener('online', this.onOnline);
    window.addEventListener('offline', this.onOffline);
  }

  ngOnDestroy(): void {
    if (!this.isBrowser) return;
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
  }
}
